import '.q{display:grid;}.ssr-plugin'
import '.s{gap:1.5rem;}.ssr-plugin'
import { InitiativeCard } from '@app/components/blocks/card/InitiativeCard'
import { styled } from 'inlines'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { ViewHousingFormModel } from 'functions/app/housing-form/view'
import { pages } from '@app/util/links'
import { labelAddressBuilder } from '@app/util/helpers'

export const HousingFormPagePlots = ({
  housingForm,
}: {
  housingForm: ViewHousingFormModel
}) => {
  const t = useTranslations().app
  const isMobile = useMediaQuery()

  return (
    <div className="q s"
      style={{
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
      }}
    >
      {housingForm?.plots?.map((plot) => (
        <InitiativeCard
          key={plot.id}
          to={pages.plot(plot.slug)}
          image={plot.media?.[0]?.src ?? defaultProjectPicture}
          title={plot.name}
          description={plot.description}
          location={labelAddressBuilder(
            plot.location.address,
            t.common.notSpecified,
          )}
          tagText={
            t.common.plotApplicationStatus[
              plot.applicationStatus as keyof typeof t.common.plotApplicationStatus
            ]
          }
          tagVariant={
            plot.applicationStatus === 'applicationOpen' ? 'green' : 'gray'
          }
        />
      ))}
    </div>
  )
}
